var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup25(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.919,
    height: 167.21,
    viewBox: "0 0 124.919 167.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25",
    transform: "translate(-435.139 -1303.74)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 117",
    d: "M1598.844,303.744H1552.5a17.323,17.323,0,0,0-16.89,13.45h42.78a23.366,23.366,0,0,1,23.34,23.34v43.99a17.341,17.341,0,0,0,14.449-17.1v-46.34a17.342,17.342,0,0,0-17.339-17.34",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 118",
    d: "M1578.394,323.194h-46.34a17.342,17.342,0,0,0-17.34,17.34v.11h40.23a23.366,23.366,0,0,1,23.34,23.34v40.23h.11a17.336,17.336,0,0,0,17.34-17.34v-46.34a17.342,17.342,0,0,0-17.34-17.34",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 119",
    d: "M1510.084,410.034a15.989,15.989,0,0,1,1.58-.68v-41.79c0-.35.01-.69.03-1.03v-.05l.03-.27a13.245,13.245,0,0,1,26.42,1.35v34.63h23.61a17.436,17.436,0,0,1,7.16,1.52c.35.15.7.32,1.04.5a18.4,18.4,0,0,1,2.33,1.43v-41.66a17.342,17.342,0,0,0-17.34-17.34H1508.6a17.342,17.342,0,0,0-17.34,17.34v46.34a17.321,17.321,0,0,0,10.93,16.11,14.785,14.785,0,0,1-.32-3.03,14.94,14.94,0,0,1,8.21-13.37",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 120",
    d: "M1569.984,410.214a12.937,12.937,0,0,0-8.24-3.02h-28.6v-39.63a8.242,8.242,0,0,0-16.44-.84v.01a7.557,7.557,0,0,0-.04.83v45.85a10.53,10.53,0,0,0-4.31,1.08,9.935,9.935,0,0,0-5.01,11.9l.39,1.25,1.87,6.02,3.38,10.87,3.68,11.81v1.83a12.784,12.784,0,0,0,12.77,12.78h27.89a12.793,12.793,0,0,0,12.79-12.78l.93-8.16,2.6-22.35.46-4.03.42-3.67a12.613,12.613,0,0,0-2.39-7.42,12.2,12.2,0,0,0-2.15-2.33",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25);
export default __webpack_public_path__ + "static/media/Group 25.1245e71a6cc81e7d699236c35e6f4749.svg";
export { ForwardRef as ReactComponent };